import React from "react";
import { Loader } from "../";
import { useAuth } from "../../context/Auth";

export const GlobalLoader = () => {
  const { globalLoader } = useAuth();

  return globalLoader ? <Loader /> : null;
};
